module.exports = __webpack_public_path__ + "img/product1.402d574f.png";